// A large coloured bubble on the bottom-right corner of the in-page logo that says which
// environment this is: red on dev, yellow on stage, nothing on prod. The logo
// itself keeps its normal colours everywhere. The environment comes from the
// hostname (see `lib/appEnv.ts`); the favicon carries the same dot.

import { ENV_BADGE_COLOR, currentAppEnv } from '@/lib/appEnv';

export function EnvBubble() {
  const env = currentAppEnv();
  if (env === 'prod') return null;
  return (
    <span
      role="img"
      aria-label={env === 'dev' ? 'Development environment' : 'Staging environment'}
      title={env === 'dev' ? 'Development environment' : 'Staging environment'}
      data-env-badge={env}
      className="absolute -bottom-2 -right-3 h-6 w-6 rounded-full border-2 border-white shadow-sm dark:border-candy-dark-surface"
      style={{ backgroundColor: ENV_BADGE_COLOR[env] }}
    />
  );
}
